import React from 'react'

const RenderInput = ({input, label, type, help, meta: {touched, error, warning}}) => (
  <div className={"form-group" + (touched && ((error && " has-error") || (warning && " has-warning")) || "")}>
    <label className="control-label">{label}</label>
    <div>
      <input className="form-control" {...input} placeholder={label} type={type} />
      <p className="help-block">{help}</p>
      {touched &&
        ((error && <span className="text-danger"><i className="fa fa-exclamation-circle" /> {error}</span>) ||
          (warning && <span className="text-warning">{warning}</span>))}
    </div>
  </div>
)

export default RenderInput


// WEBPACK FOOTER //
// ./src/components/RenderInput.js